import { IsDevEnv } from '../../Settings'
import { fakeProfile, testers } from '../testers'
import { fields, form, zodValidator } from '@codeleap/form'
import { t } from '@lingui/core/macro'
import { login } from './login'
import z from 'zod'

const initialState = IsDevEnv ? testers.default : undefined

const signupPasswordField = fields.text({
  ...login.fields.password.options,
  defaultValue: fakeProfile.password,
})

export const createSignup = (withPassword = false) => {
  return form('signup', {
    email: fields.text(login.fields.email.options),
    password: signupPasswordField,
    birthday: fields.date({
      label: t`Date of birth`,
      placeholder: t`Birthday`,
      defaultValue: fakeProfile.birthday,
    }),
    first_name: fields.text({
      label: t`First Name`,
      defaultValue: initialState?.first_name,
      placeholder: 'John',
      validate: zodValidator(z.string().min(1)),
    }),
    last_name: fields.text({
      label: t`Last Name`,
      defaultValue: initialState?.last_name,
      placeholder: 'Doe',
      validate: zodValidator(z.string().min(1)),
    }),
    repeatPassword: fields.text({
      ...login.fields.password.options,
      label: t`Confirm Password`,
      defaultValue: fakeProfile.repeatPassword,
      validate: (value) => {
        const isValid = value === signupPasswordField.value
        return {
          isValid: withPassword ? true : isValid,
          error: isValid || withPassword ? null : [{ message: t`Passwords don't match` }]
        }
      }
    }),
    tester: login.fields.tester,
    avatar: fields.file(),
    terms: fields.boolean({
      label: t`Accept terms and conditions`,
      defaultValue: true,
      validate: (accepted) => {
        return {
          isValid: accepted,
          error: accepted ? null : [{ message: t`You need to accept our Terms & Conditions to register` }]
        }
      }
    }),
  })
}

export const signup = createSignup(true)
export const socialSignup = createSignup(false)